import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import { AppSharedUIModule } from 'app-shared-ui';
import { TranslocoRootModule } from 'app-core';

import { AuthGuard } from '../guards/auth.guard';
import { BankAccountComponent } from './bank-account/bank-account.component';
import { ManageReferralsComponent } from './manage-referral/manage-referral.component';
import { ProductPresentationUsersComponent } from './product-presentation-users/product-presentation-users.component';
import { ProductPresentationDoctorsComponent } from './product-presentation-doctors/product-presentation-doctors.component';
import { ProductPresentationSalesComponent } from './product-presentation-sales/product-presentation-sales.component';
import { ReferralComponent } from './referral/referral.component';
import { WebsitesComponent } from './websites/websites.component';
import { ProductPresentationScanComponent } from './product-presentation-scan/product-presentation-scan.component';

@NgModule({
  declarations: [
    BankAccountComponent,
    ManageReferralsComponent,
    ProductPresentationDoctorsComponent,
    ProductPresentationScanComponent,
    ProductPresentationSalesComponent,
    ProductPresentationUsersComponent,
    ReferralComponent,
    WebsitesComponent
  ],
  imports: [
    AppSharedUIModule,
    CommonModule,
    RouterModule.forChild([
      {
        path: 'manage/referral',
        component: ReferralComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manage/referrals',
        component: ManageReferralsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manage/bank-account',
        component: BankAccountComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manage/product/presentation/users',
        component: ProductPresentationUsersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manage/product/presentation/doctors',
        component: ProductPresentationDoctorsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manage/product/presentation/scan',
        component: ProductPresentationScanComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manage/product/presentation/sales',
        component: ProductPresentationSalesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manage/websites',
        component: WebsitesComponent,
        canActivate: [AuthGuard]
      },
    ]),
    MatDividerModule,
    NgxDocViewerModule,
    TranslocoRootModule,
  ],
  providers: [
  ]
})
export class OrganizationModule { }
